import { ConceptService } from "../services";

export const concept = {
  state: () => ({
    concepts: [],
    selectedConcepts: [],
    current: null,
  }),
  mutations: {
    setConcepts: (state, value) => (state.concepts = value || []),
    setSelectedConcepts: (state, value) => (state.selectedConcepts = value || []),
    setCurrentConcept: (state, value) => (state.current = value || null),
  },
  actions: {
    CONCEPT_FIND_ALL: async ({ commit }, params = {}) => {
      const response = await ConceptService.findAll(params);
      if (response.ok) {
        commit("setConcepts", response.data || []);
      } else {
        alert(response.message || "No fue posible obtener los conceptos");
      }
      return response;
    },
    CONCEPT_FIND_ONE: async ({ commit }, id) => {
      const response = await ConceptService.findById(id);
      if (response.ok) {
        commit("setCurrentConcept", response.data || null);
      } else {
        alert(response.message || "No fue posible obtener el concepto");
      }
      return response;
    },
    CONCEPT_CREATE: async ({ dispatch }, payload) => {
      const response = await ConceptService.create(payload);
      if (response.ok) {
        await dispatch("CONCEPT_FIND_ALL");
      }
      return response;
    },
    CONCEPT_UPDATE: async ({ dispatch }, { id, ...payload }) => {
      const response = await ConceptService.update({ id, ...payload });
      if (response.ok) {
        await dispatch("CONCEPT_FIND_ALL");
      }
      return response;
    },
    CONCEPT_DELETE: async ({ dispatch }, id) => {
      const response = await ConceptService.remove(id);
      if (response.ok) {
        await dispatch("CONCEPT_FIND_ALL");
      }
      return response;
    },
  },
  getters: {
    conceptById: (state) => (id) => state.concepts.find((concept) => concept.id === id) || null,
  },
};
